// import React, { useEffect, useRef } from "react";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import ServitorInvoiceTemplate from "./ServitorInvoiceTemplate";

// const ServitorReceiptGenerator = ({ order, onFinish }) => {
//   const invoiceRef = useRef();
//   const hasGeneratedRef = useRef(false);

//   useEffect(() => {
//     const generatePDF = async () => {
//       if (!invoiceRef.current) return;

//       try {
//         const canvas = await html2canvas(invoiceRef.current, {
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/png");

//         const pdf = new jsPDF("p", "mm", "a4");
//         const pageWidth = pdf.internal.pageSize.getWidth();
//         const pageHeight = pdf.internal.pageSize.getHeight();

//         const imgProps = pdf.getImageProperties(imgData);
//         const imgWidthPx = imgProps.width;
//         const imgHeightPx = imgProps.height;

//         const marginMM = 10;
//         const maxWidthMM = pageWidth - 2 * marginMM;
//         const maxHeightMM = pageHeight - 2 * marginMM;

//         const scaleX = maxWidthMM / imgWidthPx;
//         const scaleY = maxHeightMM / imgHeightPx;
//         const scale = Math.min(scaleX, scaleY);

//         const pdfImgWidth = imgWidthPx * scale;
//         const pdfImgHeight = imgHeightPx * scale;

//         const xOffset = (pageWidth - pdfImgWidth) / 2;
//         const yOffset = (pageHeight - pdfImgHeight) / 2;

//         pdf.addImage(
//           imgData,
//           "PNG",
//           xOffset,
//           yOffset,
//           pdfImgWidth,
//           pdfImgHeight
//         );
//         pdf.save(`HelpNao_Servitor_Receipt_${order.order_number}.pdf`);
//       } catch (err) {
//         console.error("Error generating PDF:", err);
//       } finally {
//         if (typeof onFinish === "function") onFinish();
//       }
//     };

//     if (!hasGeneratedRef.current && invoiceRef.current) {
//       hasGeneratedRef.current = true;
//       generatePDF();
//     }
//   }, [order, onFinish]);

//   return (
//     <div style={{ position: "absolute", top: -9999, left: -9999 }}>
//       <ServitorInvoiceTemplate order={order} ref={invoiceRef} />
//     </div>
//   );
// };

// export default ServitorReceiptGenerator












// ***** New Updated (16-oct-2025) ***** //

import React, { useEffect, useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ServitorInvoiceTemplate from "./ServitorInvoiceTemplate";

const ServitorReceiptGenerator = ({ order, onFinish }) => {
  const invoiceRef = useRef();
  const hasGeneratedRef = useRef(false);

  useEffect(() => {
    const generatePDF = async () => {
      if (!invoiceRef.current) return;

      try {
        // --- Page + margins (mm) ---
        const pageFormat = "a4";
        const marginMM = 10;

        // Create a temp pdf to read exact page size in mm
        const probe = new jsPDF({ orientation: "p", unit: "mm", format: pageFormat });
        const pageWidthMM = probe.internal.pageSize.getWidth();
        const pageHeightMM = probe.internal.pageSize.getHeight();
        const maxWidthMM = pageWidthMM - 2 * marginMM;
        const maxHeightMM = pageHeightMM - 2 * marginMM;

        // --- Target DPI for crispness (kept consistent with customer receipt)
        const targetDPI = 316;

        // convert our drawing box to pixels
        const targetImgWidthPx  = Math.round((maxWidthMM  / 25.4) * targetDPI);
        const targetImgHeightPx = Math.round((maxHeightMM / 25.4) * targetDPI);

        // element size (CSS pixels)
        const el = invoiceRef.current;
        const elWidthPx  = Math.max(el.scrollWidth, el.clientWidth);
        const elHeightPx = Math.max(el.scrollHeight, el.clientHeight);

        // scale so it fills the content box while respecting aspect
        const scaleX = targetImgWidthPx  / elWidthPx;
        const scaleY = targetImgHeightPx / elHeightPx;
        const scale  = Math.max(1.0, Math.min(3.0, Math.max(scaleX, scaleY))); // clamp 1.0–3.0

        // Render high-quality canvas
        const canvas = await html2canvas(el, {
          scale,
          useCORS: true,
          allowTaint: false,
          backgroundColor: "#ffffff",
          imageTimeout: 15000,
          removeContainer: true,
          onclone: (doc) => {
            const c = doc.querySelector(".ServitorReceipt-container");
            if (c) c.style.transform = "translateZ(0)";
          },
        });

        // Encode to JPEG with adaptive quality (keeps 1–2 MB)
        let quality = 0.9;
        let imgData = canvas.toDataURL("image/jpeg", quality);
        const baseLen = "data:image/jpeg;base64,".length;
        const bytes = Math.ceil((imgData.length - baseLen) * 0.75);
        if (bytes > 2.5 * 1024 * 1024) {
          quality = 0.82;
          imgData = canvas.toDataURL("image/jpeg", quality);
        }

        // Build PDF with compression
        const pdf = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: pageFormat,
          compressPdf: true,
        });

        // fit into content box (mm)
        const imgProps = pdf.getImageProperties(imgData);
        const imgWpx = imgProps.width;
        const imgHpx = imgProps.height;

        const scalePdfX = maxWidthMM / imgWpx;
        const scalePdfY = maxHeightMM / imgHpx;
        const pdfScale  = Math.min(scalePdfX, scalePdfY);

        const pdfImgW = imgWpx * pdfScale;
        const pdfImgH = imgHpx * pdfScale;

        const x = (pageWidthMM - pdfImgW) / 2; // centered horizontally
        const y = marginMM;                     // fixed top margin (no big top gap)

        pdf.addImage(imgData, "JPEG", x, y, pdfImgW, pdfImgH);
        pdf.setProperties({
          title: `HelpNao Servitor Receipt ${order.order_number}`,
          author: "HelpNao",
          subject: "Servitor Receipt",
        });
        pdf.save(`HelpNao_Servitor_Receipt_${order.order_number}.pdf`);
      } catch (err) {
        console.error("Error generating PDF:", err);
      } finally {
        if (typeof onFinish === "function") onFinish();
      }
    };

    if (!hasGeneratedRef.current && invoiceRef.current) {
      hasGeneratedRef.current = true;
      generatePDF();
    }
  }, [order, onFinish]);

  // Off-screen render
  return (
    <div style={{ position: "absolute", top: -9999, left: -9999 }}>
      <ServitorInvoiceTemplate order={order} ref={invoiceRef} />
    </div>
  );
};

export default ServitorReceiptGenerator;
